import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { AccountingChangeDetectionService } from '../services/accounting-change-detection.service';

/**
 * Accounting backend controllers (Account*, AccountingImport, AuditLog, …).
 * Matches both absolute URLs and dev-proxy relative paths.
 */
const ACCOUNTING_API_PATTERN = /\/(Account|AccountingImport|AuditLog)(?:\/|$)/i;

/**
 * HTTP fallback for accounting calls that bypass {@link ApiService} (blob downloads, FormData).
 * Relies on {@link AccountingChangeDetectionService.registerRoot} from accounting layout.
 */
export const accountingChangeDetectionInterceptor: HttpInterceptorFn = (req, next) => {
  if (!ACCOUNTING_API_PATTERN.test(req.url)) {
    return next(req);
  }

  const cd = inject(AccountingChangeDetectionService);

  return next(req).pipe(
    finalize(() => {
      queueMicrotask(() => cd.notify());
    }),
  );
};
